import script from "./Majblomman.vue?vue&type=script&lang=ts&setup=true"
export * from "./Majblomman.vue?vue&type=script&lang=ts&setup=true"

import "./Majblomman.vue?vue&type=style&index=0&id=18d69e3b&lang=scss"

const __exports__ = script;

export default __exports__